import { render } from "./ocr_verification.html?vue&type=template&id=5bce32b2&external"
import script from "./ocr_verification.js?vue&type=script&lang=js&external"
export * from "./ocr_verification.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__